import type { ToastGlassBackgroundProps } from './ToastGlassBackground.types';

/**
 * Frosted-glass backdrop for the Toast — WEB is a no-op: the browser
 * renders the glass via the CVA's `web:backdrop-blur-[6px]` on the card element
 * itself (real CSS `backdrop-filter`, clipped to the rounded corners). The
 * native sibling (`ToastGlassBackground.native.tsx`) drops an `expo-blur`
 * BlurView instead (iOS), or an opaque fill (Android), since React Native has
 * no `backdrop-filter`.
 */
export function ToastGlassBackground(_props: ToastGlassBackgroundProps): null {
  return null;
}
